import React, { useEffect, useState, useMemo } from 'react';
import { useCSVDownloader } from 'react-papaparse';
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useNavigate } from 'react-router-dom';
import { exportToCSV, exportToExcel, exportToPDF } from '../../utils/Exports';
import { FormGroup, Button, Label, Form, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import $ from 'jquery';
import moment from 'moment';
import formatHeaderName from '../../utils/formatHeaderName';
import { parseValue } from '../../utils/Common';
import Table from '../common/Table';


const common = require('../../utils/Common');

function LogisticReports() {
    const [rowData, setRowData] = useState([]);
    const [columnDefs, setColumnDefs] = useState([]);
    const { CSVDownloader } = useCSVDownloader();
    const [totalRecords, setTotalRecords] = useState(0);
    const [userRights, setUserRights] = useState({view: false, edit: false, delete: false, create: false});
    const navigate = useNavigate();

    useEffect(() => {
        checkAccess();
    }, []);

    const checkAccess = async () => {
        let rights = await common.checkAccessRights(window.location.pathname);
        if (!rights.view) {
          alert("Access Denied");
          navigate("/");
          return;
        } else {
            setUserRights(rights);
            getReportData();
        }
    }

    const getReportData = async (limit = 10, offset = 0, search = {}) => {
        var parameters = {
            'source': 'Admin',
            'report_name': 'logistic_reports',
            'start_date': $('#Date-from').val(),
            'end_date': $('#Date-to').val(),
            'limit': limit,
            'offset': offset
        };
        let response = await common.apiRequest('post', '/reports/get-reports', parameters);
        let data = (response.data && response.data.data) ? response.data.data : [];
        const keysToExclude = ['order_item_id'];
        const cols = common.getReportColumns(keysToExclude, data.keys, ChangeIntDecimals);
        setColumnDefs(cols);
    
        // Set row data
        setRowData(data.reportData);
        setTotalRecords(data.totalRecords);

    };
      const ChangeIntDecimals = [
        'order_price','taxable_value','sigst','scgst','ssgst','sutgst'
       ];

      const excludeFields = ['order_item_id'];

      const data = rowData.map((row, index) => {
        const newRow = {
            slNo: index + 1 
        };
          Object.keys(row)
              .filter(key => !excludeFields.includes(key))
              .forEach(key => {
                  newRow[formatHeaderName(key)] = row[key];
              });
          return newRow;
      });
    const handleExportCSV = () => {
        exportToCSV(data, 'Logistics report');
    }
    
    const handleExportExcel = () => {
        exportToExcel(data, 'Logistics report');
    }
    
    const handleExportPDF = () => {
        exportToPDF(data, 'Logistics report');
    }
    return (
        <>
            <div className="row report-margin">
        <div className='col-md-10'>
        <h3>Logistics Reports</h3>
        </div>
        <Form className='row'>
                        <FormGroup className='col-md-4 row'>
                            <Label className="col-md-2 col-form-label" for="Date-from">From:</Label>
                            <input type='date' defaultValue={moment().startOf('month').format('YYYY-MM-DD')} onChange={() => getReportData()} className="form-control col-md-5" id="Date-from" name="Date-from"></input>
                        </FormGroup>
                        <FormGroup className='col-md-4 row'>
                            <Label className=" col-md-2 col-form-label" for="Date-to">To:</Label>
                            <input type='date' defaultValue={moment().endOf('month').format('YYYY-MM-DD')} onChange={() => getReportData()} className="form-control col-md-5" id="Date-to" name="Date-to"></input>
                        </FormGroup>
                    </Form>
        <div className="col-md-12 button-container">
          
          <button className='btn button-product' onClick={handleExportCSV}>Export to CSV</button>
         <button className='btn button-product' onClick={handleExportExcel}>Export to Excel</button>
         <button className='btn button-product' onClick={handleExportPDF}>Export to PDF</button>

        </div>
      </div>
            <div className='row'>
                <div className='col-md-12'>
                    <div className="ag-theme-quartz" style={{height: 600, width: '100%'}}>
                        <Table 
                          columns={columnDefs}
                          data={rowData}
                          totalRecords={totalRecords}
                          pageSize={10}
                          onPageChange = {getReportData}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default LogisticReports;